const d =
	'M480-95q-84 0-145-42t-84-97H135v-72h91q-5-22-5-47.5V-400h-86v-72h86v-49q0-28 7-53h-93v-72h123q10-25 36.5-52t51.5-39l-78-76 50-49 94 94q28-11 67.5-11.5T545-770l95-96 49 49-74 74q26 13 53.5 43.5T709-640h118v66h-95q7 22 7.5 51t.5 51h87v72h-87v46.5q0 25.5-6 47.5h93v72H711q-23 54-84.5 96.5T480-95Zm-80-219h160v-72H400v72Zm0-173h160v-72H400v72Z';

export default d;
